import {jQuery as $, lodash as _} from 'lib/shim';
import { BREAKPOINT_DESKTOP, BREAKPOINT_TABLET } from 'defines';

import {waitForRepaint} from 'util/dom';



const SELECTOR = '.organism-product-teaser-list';



class OrganismProductTeaserList {

	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$teaserGroupWrapper = this._$element.find('.breakout-wrapper .teaser-group-wrapper');
			this._$teaserBackgroundHolder = this._$element.find('.breakout-wrapper .teaser-background-holder');
			this._$teaser = this._$teaserGroupWrapper.find('.molecule-teaser-list-item').first();
			this._$teaserImage = this._$teaser.find('.image-holder').first();
			this._$teaserContent = this._$teaser.find('.content-holder').first();


			this._prime();
		}

		return $element;
	}



	_prime() {
		this._app.registerWaitForWebFontsCallback('product-teaser-list-background-'+this._id, () => {
			waitForRepaint(() => {
				this._setBackgroundPosition();
			});
		});


		this._app.registerResizeCallback('product-teaser-list-background-'+this._id, () => {
			waitForRepaint(() => {
				this._setBackgroundPosition();
			});
		});
	}



	_setBackgroundPosition() {
		if (this._$teaserImage.length > 0) {
			let imageHeight = this._$teaserImage.outerHeight(),
				backgroundBottomPosition = (imageHeight + 50) - 200; // 50px is the stick out value and 200px is the background-gradient height

			this._$teaserBackgroundHolder.css('top', backgroundBottomPosition).removeClass('cloaked');
		}
	}
}



export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new OrganismProductTeaserList(app, $this));
	});

	return $elements;
}
